"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styles_1 = require("./styles");
var theme_1 = require("../theme"); // tslint:disable-line
var FloatingPlaceholder = /** @class */ (function (_super) {
    tslib_1.__extends(FloatingPlaceholder, _super);
    function FloatingPlaceholder(props) {
        var _this = _super.call(this, props) || this;
        _this.inputHasValue = false;
        _this.handleEndBlurTransition = function () {
            if (!_this.inputHasValue) {
                setTimeout(function () {
                    _this.setState({
                        transition: false
                    });
                }, 200);
            }
        };
        _this.hanldeEndFocusTransition = function () {
            // this fixes the issue with placeholder not firing on first focus.
            // getBoundingClientRect on the internal span needs another cycle to
            // grab the width.
            _this.setState({
                transition: false
            });
        };
        _this.hasValue = function (value) {
            return !!(value && value.length > 0);
        };
        _this.handleOnBlur = function (event, onBlur) {
            _this.setState({
                floating: _this.hasValue(_this.state.inputField.value),
                hasFocus: false,
                shouldAnimate: true,
                transition: true,
            }, _this.handleEndBlurTransition);
            if (onBlur) {
                onBlur(event);
            }
        };
        _this.handleOnFocus = function (event, onFocus) {
            if (!_this.state.hasFocus) {
                var placeholder = event.target.placeholder;
                _this.setState({
                    floating: true,
                    hasFocus: true,
                    placeholder: _this.state.placeholder || placeholder,
                    transition: true,
                    shouldAnimate: true,
                }, _this.hanldeEndFocusTransition);
            }
            if (onFocus) {
                onFocus(event);
            }
        };
        _this.handleRefCallback = function (ref) {
            if (!_this.state.inputField) {
                setTimeout(function () {
                    var theme = _this.props.theme;
                    var styles = _this.state.styles;
                    var newStyles = tslib_1.__assign({}, styles);
                    if (ref && Object.keys(styles).length === 0) {
                        var tagName = ref.tagName.toLowerCase();
                        var components = Object.keys(theme.components);
                        for (var i = 0; i < components.length; i++) {
                            if (components[i].toLowerCase() === tagName) {
                                newStyles = theme.components[components[i]][_this.variant];
                                break;
                            }
                        }
                    }
                    _this.setState({
                        floating: _this.hasValue(ref.value),
                        inputField: ref,
                        placeholder: ref.placeholder,
                        shouldAnimate: false,
                        styles: newStyles,
                        transition: true,
                    }, _this.hanldeEndFocusTransition);
                }, 0);
            }
        };
        _this.state = {
            floating: false,
            hasFocus: false,
            hasHover: false,
            inputField: undefined,
            placeholder: undefined,
            shouldAnimate: true,
            styles: {},
            transition: false,
        };
        _this.floatingPlaceholder = react_1.default.createRef();
        return _this;
    }
    FloatingPlaceholder.prototype.getBackGroundColor = function () {
        var _a = this.props, pageBackgroundColor = _a.pageBackgroundColor, theme = _a.theme;
        return pageBackgroundColor || theme.palette.light;
    };
    FloatingPlaceholder.prototype.calcInternalSpanStyles = function () {
        var hideBorder = this.props.hideBorder;
        var _a = this.state, inputField = _a.inputField, floating = _a.floating;
        if (!this.floatingPlaceholder || !inputField || !hideBorder) {
            return {};
        }
        var inputStyles = window.getComputedStyle(inputField);
        var placeholderPaddingLeft = inputStyles.getPropertyValue('padding-left');
        if (!placeholderPaddingLeft || placeholderPaddingLeft === '0px') {
            placeholderPaddingLeft = inputStyles.getPropertyValue('padding');
        }
        if (!this.coverWidth) {
            this.coverWidth = this.floatingPlaceholder && this.floatingPlaceholder.current
                ? this.floatingPlaceholder.current.getBoundingClientRect().width : 0.01;
        }
        var coverWidth = this.coverWidth * 0.75 - 14; // 75% scale when floating and 14 padding
        return {
            background: this.getBackGroundColor(),
            height: inputStyles.getPropertyValue('border-top-width'),
            left: placeholderPaddingLeft,
            width: !floating ? 0.01 : coverWidth,
        };
    };
    FloatingPlaceholder.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, hideBorder = _a.hideBorder, offset = _a.offset, _b = _a.status, status = _b === void 0 ? 'default' : _b;
        var _c = this.state, floating = _c.floating, inputField = _c.inputField, placeholder = _c.placeholder, shouldAnimate = _c.shouldAnimate, styles = _c.styles, transition = _c.transition;
        if (react_1.default.Children.count(children) !== 1) {
            console.warn('Labels should have only one child.'); // tslint:disable-line
        }
        var clones = react_1.default.Children.map(children, function (child) {
            _this.variant = child.props.variant || 'default';
            _this.inputWidth = child.props.width;
            _this.inputHasValue = _this.hasValue(child.props.value);
            return react_1.default.cloneElement(child, {
                innerRef: _this.handleRefCallback,
                onBlur: function (event) { _this.handleOnBlur(event, child.props.onBlur); },
                onFocus: function (event) { _this.handleOnFocus(event, child.props.onFocus); },
                placeholder: floating || transition ? '' : child.props.placeholder,
            });
        });
        var tagName = (inputField && inputField.tagName.toLowerCase()) || undefined;
        var placeholderThemeStyles = shouldAnimate ? styles_1.transitionStyles : {};
        var showFloat = tagName && floating;
        var hasFocusStyles = {
            transform: "translate(" + (showFloat ? 8 : 0) + "px, " + (showFloat ? -(offset || 20) : 0) + "px) scale(" + (showFloat ? 0.75 : 1) + ")",
            color: this.props.theme.components.floatingPlaceholder.color,
        };
        var borderCoverStyles = this.calcInternalSpanStyles();
        var computedClassName = theme_1.css(tslib_1.__assign({}, styles, { borderColor: 'transparent', boxShadow: 'none' }, placeholderThemeStyles, hasFocusStyles, { visibility: floating || transition ? 'visible' : 'hidden', background: 'inherit', transition: 'transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms' }));
        return (react_1.default.createElement(styles_1.StyledLabel, { width: this.inputWidth, labelText: "", status: status },
            clones,
            hideBorder &&
                react_1.default.createElement(styles_1.BorderCover, { className: theme_1.css(tslib_1.__assign({}, borderCoverStyles)) }),
            react_1.default.createElement(styles_1.FloatPlaceholder, { innerRef: this.floatingPlaceholder, className: computedClassName + " placeholder" }, placeholder)));
    };
    FloatingPlaceholder.defaultProps = {
        hideBorder: false,
        offset: 20,
        status: 'default',
    };
    return FloatingPlaceholder;
}(react_1.default.PureComponent));
exports.FloatingPlaceholder = FloatingPlaceholder;
exports.default = theme_1.withTheme(FloatingPlaceholder);
